import React, { useReducer } from 'react';
import GlobalContext from './globalContext';
// Auth removed - not needed for static site
// import { Auth } from 'aws-amplify'

import { SET_ALERT, CLEAR_ALERT, SET_AUTH, CLEAR_USER } from '../types';
import GlobalReducer from './globalReducer';


const GlobalState = props => {
    const initialState = {
        alert: null,
        loading: false,
        auth: {
            isAuthenticated: false,
            id: '',
            username: '',
            email: '',
            phone: '',

        }
    }


    const [state, dispatch] = useReducer(GlobalReducer, initialState);

    // Show Alert
    const showAlert = (msg, type) => {
        dispatch({ type: SET_ALERT, payload: { msg, type } });
        setTimeout(() => {
            dispatch({ type: CLEAR_ALERT })
        }, 2500);
    }

    // Set Auth - stubbed out (no Cognito)
    const setAuth = async (newAuth) => {
        console.log('Auth disabled - form submitted:', newAuth);
    }

    // Clear User
    const clearUser = () => dispatch({ type: CLEAR_USER });


    return (
        <GlobalContext.Provider
            value={{
                alert: state.alert,
                loading: state.loading,
                auth: state.auth,
                showAlert,
                setAuth

            }}
        >
            {props.children}
        </GlobalContext.Provider>
    )
}
export default GlobalState;